import {BaseCachedService} from './Core/BaseCachedService';

class ContextNodeTypeService extends BaseCachedService {
    get Url() { return super.Url + "/contextNodeTypes"; }
    get ModelName() { return "ContextNodeType"; }
    get PrimaryKeyProperty() { return "contextNodeTypeId"; }
    get TitleProperty() { return "name"; }
}

export const service = new ContextNodeTypeService();

